import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function TBGOSection() {
  const { t } = useTranslation(['ui', 'intro'])
  const text = 'intro:sections.tgbo'

  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const onPress = () => router.navigate('/deals?type=tgbo')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          classNameDesc="w-2/3 pr-12"
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/lady-tgbo.png'),
            imageWrapperStyle: {
              width: '95%',
              height: '95%',
            },
            imageStyle: {
              transform: [
                { translateX: Platform.select({ default: 0, web: -50 }) },
                { translateY: 0 },
              ],
            },
            blur: Platform.select({ default: 100, web: 25 }),
            blurStyle: {
              transformOrigin: 'center',
              opacity: Platform.select({ default: 0.75, web: 0.75 }),
              transform: [
                { translateX: Platform.select({ default: -60, web: -40 }) },
                { translateY: Platform.select({ default: 25, web: 25 }) },
                { scale: Platform.select({ default: 0.6, web: 0.6 }) },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
